import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const DonutChart = ({ donutChartData, donutChartOptions }) => {
  const [chartData, setChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});

  // Update chart data and options when props change
  useEffect(() => {
    setChartData(donutChartData);
    setChartOptions(donutChartOptions);
  }, [donutChartData, donutChartOptions]); // Update only when props change

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartData}
      type='donut'
      width='100%'
      height='100%'
    />
  );
};

export default DonutChart;
